import type { NavLink } from "@/types/NavLink";

export const NAV_LINKS: NavLink[] = [
  { label: "Accueil", href: "/" },
  { label: "Première visite", href: "/premiere-visite" },
  { label: "À propos", href: "/a-propos" },
  { label: "Prédications", href: "/predications" },
  // { label: 'Événements',      href: '#' },
  { label: "Contact", href: "/contact" },
];
